var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-layout",class:{ 'gift-layout--christmas': _vm.isChristmas }},[(_vm.isBegHeader)?_c('BegHeaderComponent'):_c('GiftHeaderComponent'),_vm._t("default"),_c('div',{staticClass:"gift-layout__bg-image"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }